module.exports = __webpack_public_path__ + "img/banner.969469f5.jpg";